// extracted by mini-css-extract-plugin
export default {"root":"TopicListHeader_root__iFy1r"};